module.exports = __webpack_public_path__ + "img/small-triangle-icon.3b9cdf99.svg";